<template>
  <div>
    <ListingComponent class="bg-white"
                      ref="dispatchersList"
                      :addNewButton="addNewButton"
                      :requestProvider="requestProvider"
                      :columnConfig="columnConfig">
    </ListingComponent>
    <DispatcherModal ref="dispatcherModal" @onSaveDispatcher="onSaveDispatcher"></DispatcherModal>
    <b-modal ref="confirm-modal" title="Please confirm"
             @cancel="this.hideConfirmModal"
             :ok-title="this.getStatusMessage(this.status)"
             @ok="updateStatus()">
      <h4>Are you sure, want to {{this.statusMessage.toLocaleLowerCase()}} {{this.getUserName(this.item)}}?</h4>
    </b-modal>
  </div>
</template>

<script>
import ListingComponent from '@/components/listing/ListingComponent'
import DispatcherModal from './DispatcherModal'
import '@/mixins/generalMixin'
import { USER_STATUS_ACTIVE, USER_STATUS_INACTIVE } from '../../constants'
export default {
  name: 'DispatchersList',
  data () {
    return {
      item: null,
      status: '',
      statusMessage: '',
      columnConfig: [
        {
          columnCode: 'name',
          columnName: 'Full Name',
          align: 'left',
          value: item => {
            return item.Name
          }
        },
        {
          columnCode: 'email',
          columnName: 'Email Address',
          align: 'left',
          value: item => {
            return item.Email
          }
        },
        {
          columnCode: 'phone',
          columnName: 'Mobile Phone Number',
          align: 'left',
          value: item => {
            return item.Phone
          }
        },
        {
          columnCode: 'created_at',
          columnName: 'Registered Date',
          align: 'left',
          value: item => {
            return this.dateFormat(item.CreatedAt)
          }
        },
        {
          columnCode: 'status',
          columnName: 'Status',
          align: 'left',
          custom: true,
          value: (item) => {
            return (item.Status === USER_STATUS_ACTIVE ? (<span class="badge badge-success">Active</span>) : <span class="badge badge-danger">Inactive</span>)
          }
        },
        {
          columnCode: 'actions',
          columnName: 'Actions',
          custom: true,
          customClass: 'text-center',
          value: (item) => {
            let activate, inactivate
            if (item.Status === USER_STATUS_INACTIVE) {
              activate = <b-button variant="success" onClick={() => this.showConfirmModal(item, USER_STATUS_ACTIVE)}>Activate</b-button>
            } else {
              inactivate = <b-button variant="danger" onClick={() => this.showConfirmModal(item, USER_STATUS_INACTIVE)}>Inactivate</b-button>
            }
            return (
              <div class="action-buttons">
                {activate}
                {inactivate}
              </div>
            )
          }
        }
      ]
    }
  },
  methods: {
    requestProvider (payload) {
      return this.axios.post('api/dispatchers', payload.params)
    },
    getUserName (item) {
      if (item) {
        return item.Name
      }
      return ''
    },
    onSaveDispatcher () {
      this.$refs.dispatchersList.doRequest()
    },
    showAddModal () {
      this.$refs.dispatcherModal.show()
    },
    addNewButton () {
      return <b-button class="btn btn-success mx-1 add-button" onClick={() => this.showAddModal()}>Invite Dispatcher</b-button>
    },
    showConfirmModal (item, status) {
      if (!item.ID) return
      this.item = item
      this.status = status
      this.statusMessage = this.getStatusMessage(status)
      this.$refs['confirm-modal'].show()
    },
    hideConfirmModal () {
      this.$refs['confirm-modal'].hide()
    },
    getStatusMessage (value) {
      let result = ''
      if (value === USER_STATUS_ACTIVE) {
        result = 'Activate'
      } else if (value === USER_STATUS_INACTIVE) {
        result = 'Inactivate'
      }
      return result
    },
    updateStatus () {
      this.$refs['confirm-modal'].hide()
      const request = {
        id: this.item.ID,
        status: this.status
      }
      if (!request.id) {
        return false
      }
      this.$loading.show(true)
      this.axios.put('api/update-user-status', request)
        .then(response => {
          this.$loading.hide()
          if (response.status === 200) {
            this.$toastr.success('Successfully updated!')
            this.$refs.dispatchersList.doRequest()
          } else {
            this.$toastr.error(response.data.message)
          }
        }).catch((error) => {
          if (error.response && error.response.data.message) {
            this.$toastr.error(error.response.data.message)
          }
          this.$loading.hide()
        })
    }
  },
  components: {
    ListingComponent,
    DispatcherModal
  }
}
</script>

<style scoped>
  .action-buttons .btn{
    margin-right: 10px
  }
  .add-button {
    white-space: pre;
  }
</style>
